import React, { useState } from 'react';

import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import { useEditContactAlert, useDeleteContactAlert } from '@hooks/API/Contact/UseContactAlert';
import useFormFieldFocus from '@hooks/Utils/UseFormFieldFocus';

import { NwButton } from '@components/Gui/NwButton';
import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import { NWTextAreaCharCounter } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const AlertDrawer = ({ onClose, currentContact }) => {
    useFormFieldFocus('Alert');
    const [isDeleting, setIsDeleting] = useState(false);
    const [touchForm, setTouchForm] = useState(false);

    const { mutateAsync: onEditAlert } = useEditContactAlert();
    const { mutateAsync: onDeleteAlert } = useDeleteContactAlert();

    const initialValues = {
        Alert: '',
    };

    if (currentContact && currentContact.Alert) {
        initialValues.Alert = currentContact.AlertMessage;
    }

    const saveAlert = async (values, setSubmitting) => {
        try {
            await onEditAlert({ ContactID: currentContact.ID, Message: values.Alert });
            setSubmitting(false);
            setTouchForm(false);
            onClose('updated');
        } catch (error) {
            console.error('Save Alert Error => ', error);
            setSubmitting(false);
        }
    };

    const handleDeleteAlert = async () => {
        setIsDeleting(true);
        try {
            await onDeleteAlert({ ContactID: currentContact.ID });
            setTouchForm(false);
            setIsDeleting(false);
            onClose();
        } catch (error) {
            console.error('Save Alert Error => ', error);
            setIsDeleting(false);
        }
    };

    return (
        <NwDrawer touchForm={touchForm} onTouchForm={setTouchForm} title={'Message'} onClose={onClose}>
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    saveAlert(values, setSubmitting);
                }}
                validationSchema={Yup.object().shape({
                    Alert: Yup.string().required('Content is required'),
                })}
            >
                {({ isSubmitting, values, handleSubmit }) => (
                    <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit} layout="vertical">
                        <Field
                            component={NWTextAreaCharCounter}
                            label="Alert"
                            name="Alert"
                            type="text"
                            id="Alert"
                            value={values.Alert}
                            maxLength={2000}
                            autoSize={{ minRows: 12, maxRows: 20 }}
                        />
                        {currentContact.Alert && (
                            <NwButton
                                disabled={isDeleting}
                                loading={isDeleting}
                                label="Delete"
                                loadingLabel="Deleting..."
                                onClick={handleDeleteAlert}
                            />
                        )}
                        &nbsp;
                        <NwFormButtonsBar
                            left={
                                <NwCancelButton
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        setTouchForm(false);
                                        onClose();
                                    }}
                                />
                            }
                            right={<NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />}
                        />
                    </NwForm>
                )}
            </Formik>
        </NwDrawer>
    );
};

export default AlertDrawer;
